<div class="searchbar-whereapp">
    <div id="inserisci-servizio-div">
        <button id="inserisci-servizio-button" (click)="insertServiceDialog()">
            <mat-icon aria-hidden="false" id="inserisci-servizio-icon">add</mat-icon>
            <span id="inserisci-servizio-text">Inserisci Servizio</span>
        </button>
    </div>

    <div id="search-div">
        <i class="fa fa-filter" aria-hidden="true"></i>
        <input spellcheck="false" type="text" #filter [(ngModel)]="filterValue" placeholder="Filtra per parole chiave"
            (keydown)="onSearchKeydown($event)">
        <i class="fa fa-times" aria-hidden="true" (click)="onFilterClear();onFiltering()"></i>
        <button mat-stroked-button (click)="onFiltering()" class="ml-2" [disabled]="filterValue.length < 4 && filterValue.length > 0">Cerca</button>
    </div>
    
    <div id="type-selector">
        <mat-radio-group [formControl]="servicesType" (change)="setServiceType($event.value)" color="primary">
            <mat-radio-button value="1">Alerts</mat-radio-button>
            <mat-radio-button value="2">Servizi Geolocalizzati</mat-radio-button>
        </mat-radio-group>
    </div>

    <!-- <div id="invia-messaggio-div">
        <button id="invia-messaggio-button" (click)="newListDialog()">
            <mat-icon aria-hidden="false" id="invia-messaggio-icon">add</mat-icon>
            <span id="invia-messaggio-text">Crea Lista</span>
        </button>
    </div>
    <div id="pagination-div">
        <mat-paginator [hidePageSize]="true" [pageSize]="50" [showFirstLastButtons]="true">
        </mat-paginator>
    </div> -->
</div>

<mat-progress-bar mode="indeterminate" style="position: absolute; top: 68px; z-index: 27;" [hidden]="!this.loading">
</mat-progress-bar>

<div class="empty-list" *ngIf="emptyList">
    <span>Non è presente ancora nessun servizio, creane uno adesso.</span>
</div>

<div id="main-container">
    <!-- Tabella servizi -->
    <mat-table [dataSource]="dataSource" matSort matSortActive="subject" matSortDirection="asc" matSortDisableClear>
        <!-- Subject -->
        <ng-container matColumnDef="subject">
            <mat-header-cell *matHeaderCellDef fxFlex="30%" fxFlex.sm="30%" fxFlex.xs="30%" class="mobile-large"
                mat-sort-header>
                Titolo </mat-header-cell>
            <mat-cell *matCellDef="let service" fxFlex="30%" fxFlex.sm="30%" fxFlex.xs="30%" class="mobile-large">
                <img src="data:image/png;base64,{{ service.logo }}" width="40px" height="40px" class="mr-2"
                    style="border-radius: 50%;" />
                {{ service.subject }}
            </mat-cell>
        </ng-container>
        <!-- Content -->
        <ng-container matColumnDef="content">
            <mat-header-cell *matHeaderCellDef fxFlex="60%" fxFlex.sm="60%" fxFlex.xs="60%" class="mobile-large"
                mat-sort-header>
                Descrizione </mat-header-cell>
            <mat-cell *matCellDef="let service" fxFlex="60%" fxFlex.sm="60%" fxFlex.xs="60%" class="mobile-large">
                {{ service.content }} <span *ngIf="service.distList?.name">| {{ service.distList?.name }}</span>
            </mat-cell>
        </ng-container>
        <!-- Actions -->
        <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef fxFlex="10%" fxFlex.sm="10%" fxFlex.xs="10%" class="mobile-large">
            </mat-header-cell>
            <mat-cell *matCellDef="let service" fxFlex="10%" fxFlex.sm="10%" fxFlex.xs="10%" class="contract-icon">
                <button type="button" mat-stroked-button matTooltip="Modifica" [matTooltipShowDelay]="600"
                    (click)="onServiceDetails(service)">
                    <mat-icon fontSet="material-icons" style="color: grey;">edit</mat-icon>
                </button>
                <button type="button" mat-stroked-button matTooltip="Elimina" [matTooltipShowDelay]="600"
                    (click)="onServiceDelete(service)">
                    <mat-icon fontSet="material-icons" style="color: grey;">delete</mat-icon>
                </button>
                
            </mat-cell>
        </ng-container>

        <!-- Impostazione di righe e colonne -->
        <mat-header-row *matHeaderRowDef=" displayedColumns; sticky: true" style="height: 64px">
        </mat-header-row>

        <mat-row class="element-row" *matRowDef="let row; columns: displayedColumns; let i = index"
            [class.hidden]="!(row.idType == servicesType.value)"></mat-row>

    </mat-table>
</div>

<div class="loading" *ngIf="sub === true">
</div>